/**
 * Dev-only bridge for CRA-style env reads. Under `vite dev` the
 * `process.env.REACT_APP_*` expressions in src are NOT statically replaced
 * (the node-polyfills plugin injects a global `process` shim whose env is {}),
 * so every API/socket URL resolved to undefined and the dev app silently
 * talked to nothing. Copy REACT_APP_* values from import.meta.env (exposed via
 * `envPrefix` in vite.config.ts) into the shim so existing reads work.
 *
 * MUST be the first import of the entry module — axiosSessionBootstrap and
 * utils/config read process.env at module scope. Production builds statically
 * replace those reads, so this is a no-op there.
 */
const metaEnv: Record<string, unknown> | undefined = (import.meta as any).env

if (metaEnv && typeof process !== 'undefined' && process.env) {
  for (const [key, value] of Object.entries(metaEnv)) {
    if (key.startsWith('REACT_APP_') && (process.env as Record<string, unknown>)[key] === undefined) {
      ;(process.env as Record<string, unknown>)[key] = value
    }
  }
}

export {}
